module.exports = __webpack_public_path__ + "static/img/hzqt.475390a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hzqt.png
// module id = IdT5
// module chunks = 128